"use client";

import React from "react";
import { PaginationInfo } from "./PaginationInfo";

interface PaginationCardProps {
    currentSlide: number;
    slides: any[];
    title: string;
    onNext: () => void;
    onPrev: () => void;
}

export function PaginationCard({
    slides,
    currentSlide,
    title,
    onNext,
    onPrev,
}: PaginationCardProps) {
    return (
        <div className="md:h-[80px] w-full xl:mt-[64px] xl:ml-[52px] mb-[16px]  flex items-center">
            <div className="flex justify-between xl:justify-start items-center gap-[24px] w-full ">
                <div className="hidden md:block ">
                    <PaginationInfo currentSlide={currentSlide} title={title} />
                </div>
                <div className="flex gap-[16px] items-center bg-red-400 relative w-full md:w-fit">
                    {<button
                        onClick={onPrev}
                        aria-label="Anterior"
                        disabled={slides?.length > 1 ? false : true}
                        className={`group ${slides?.length > 1 ? "" : ""} disabled:cursor-not-allowed disabled:opacity-20 flex items-center justify-center w-[52px] h-[52px] rounded-full border border-primary-600 hover:border-primary-700 hover:bg-primary-700 transition-colors`}
                    >
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            className="text-primary-600 group-hover:text-white transition-colors"
                        >
                            <path
                                d="M19 11H7.83L12.71 6.12C13.1 5.73 13.1 5.09 12.71 4.7C12.32 4.31 11.69 4.31 11.3 4.7L4.71 11.29C4.32 11.68 4.32 12.31 4.71 12.7L11.3 19.29C11.69 19.68 12.32 19.68 12.71 19.29C13.1 18.9 13.1 18.27 12.71 17.88L7.83 13H19C19.55 13 20 12.55 20 12C20 11.45 19.55 11 19 11Z"
                                fill="currentColor"
                            />
                        </svg>
                    </button>
                    }
                    <div className="md:hidden flex-1">
                        <PaginationInfo currentSlide={currentSlide} title={title} />
                    </div>
                    {<button
                        aria-label="Proximo"
                        onClick={onNext}
                        disabled={slides?.length > 1 ? false : true}
                        className={`group flex items-center disabled:cursor-not-allowed disabled:opacity-20 justify-center w-[52px] h-[52px] rounded-full border border-primary-600 hover:border-primary-700 hover:bg-primary-700 transition-colors`}
                    >
                        <svg
                            className="rotate-180 text-primary-600 group-hover:text-white transition-colors"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M19 11H7.83L12.71 6.12C13.1 5.73 13.1 5.09 12.71 4.7C12.32 4.31 11.69 4.31 11.3 4.7L4.71 11.29C4.32 11.68 4.32 12.31 4.71 12.7L11.3 19.29C11.69 19.68 12.32 19.68 12.71 19.29C13.1 18.9 13.1 18.27 12.71 17.88L7.83 13H19C19.55 13 20 12.55 20 12C20 11.45 19.55 11 19 11Z"
                                fill="currentColor"
                            />
                        </svg>
                    </button>
                    }
                </div>
            </div>
        </div>

    );
}
